import React, {useEffect, useState} from "react";
import ActionListHeaderSheet from "../../sheet/ActionListHeaderSheet";
import FormBuilder from "../../../class/tool/FormBuilder";

const PricelistHeaderSheet = props => {
    const company = JSON.parse(localStorage.getItem("company"));
    const { object, values, errors, setGlobalError, handleChange, handleSave, handleAction } = props;
    const [ edit, setEdit ] = useState("");
    const [ rows, setRows ] = useState([
        {
            label: "",
            attribute: "name",
            inputType: "text",
            returnType: "string",
            classnameLabel: "",
            classnameInput: "noMarginTop noBackground whiteForeground high",
            classnameNoInput: "noMarginTop noBackground whiteForeground",
            placeholder: "nom",
            emptyText: "Aucun",
            edit: false
        }
    ]);
    const [ actions, setActions ] = useState([])

    const buildActions = () => {
        const env = JSON.parse(localStorage.getItem("env"))
        const settings = JSON.parse(localStorage.getItem("storeSettings"))
        let actionsTmp = []

        if (object.main === 0) {
            if (env.type === "company" || (env.type === "store" && company.socialReason !== null && settings.allowedProductCreation) || (env.type === "store" && company.socialReason === null) || object.sharedUuid === null) {
                actionsTmp.push({
                    title: "Supprimer",
                    type: "remove"
                })
            }
        }

        setActions(actionsTmp)
    }
    const buildRow = row => {
        if (edit === row.attribute || ["color"].includes(row.inputType))
            return FormBuilder.buildInputByType(row, values, errors, change, reinitEdit);
        else
            return FormBuilder.buildNoInputByType(row, values, handleEdit);
    }
    const handleEdit = attribute => {
        setEdit(attribute);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const reinitEdit = () => {
        setEdit("");
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();
        handleSave();
    }

    useEffect(() => {
        buildActions()
    }, [])

    return (
        <div className="headerSheet">
            <div className="infos">
                <p className={"titleSheet alone"}>{values.name}</p>
            </div>
            <ActionListHeaderSheet actions={ actions } handleAction={ handleAction } />
        </div>
    );
}

export default PricelistHeaderSheet;
